import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSectionFormType } from '../../../../Features/storefrontSlice';

function AboutTwo() {
    const dispatch = useDispatch();

    const viewType = useSelector((state) => state.storefront.viewType);

    function handleClick() {
        dispatch(setSectionFormType(`ABOUT_TWO${viewType === 'MOBILE' ? '' : '_DESKTOP'}`));
    }

    return (
        <button onClick={handleClick} className="p-[10px] border border-[#EAEAEA] flex flex-col items-center gap-2 rounded-2xl outline-none select-none">
            <div className="w-full h-[100px] flex gap-2 rounded-md bg-[#EAEAEA] p-2">
                <div className="flex flex-col w-full text-[#000000]">
                    <h1 className='font-semibold text-[12px] leading-5'>About us</h1>

                    <p className='font-medium text-[8px] leading-[14px]'>Unleash Your Inner Style Icon with Brand: The Ultimate Fashion Must-Have! Brand was founded by Joe Wattson in 2009 to live a more purpose-driven life. Now there's almost 20 of us working out of our sunny HQ in Goa. Come say hi!</p>
                </div>
            </div>

            <p className='font-medium text-[12px] leading-5 text-[#121212]'>About 2</p>
        </button>
    );
}

export default AboutTwo;
